module.exports = __webpack_public_path__ + "img/doorLogo17.30944e7c.png";